import { render, staticRenderFns } from "./ValidationPopup.vue?vue&type=template&id=206dc12b&"
import script from "./ValidationPopup.vue?vue&type=script&lang=js&"
export * from "./ValidationPopup.vue?vue&type=script&lang=js&"
import style0 from "./ValidationPopup.vue?vue&type=style&index=0&id=206dc12b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports